<div class="flex flex-col text-sm {{ taller ? '' : 'h-[5.45rem]' }}" [ngClass]="class">
	<div *ngIf="!custom" class="h-full">
		<label [for]="name" *ngIf="!nolabel" class="text-[#646464] mb-0">
			{{ label }}
			<!-- <span *ngIf="isRequired() || required" class="text-red-500"> *
			</span> -->
		</label>
		<ng-content select="[label]"></ng-content>
		<div class="input-container {{ taller ? '' : 'h-12' }} mt-1 {{containerClass}}">
			<ng-content></ng-content>
			<ng-content select="[icon]"></ng-content>
		</div>
	</div>
	<ng-content select="[custom]" *ngIf="custom"></ng-content>


	<span class="text-xs text-red-500 mt-0.5 ml-3" *ngIf="
	!errt &&
      form && form.controls[name] &&
      form.controls[name].errors &&
      form.controls[name].touched">
		<span *ngIf="form.controls[name].errors?.['required']">
			{{useLabelInErrorText ? label : 'This Field'}} is required
		</span>
		<span *ngIf="form.controls[name].errors?.['min']">
			Minimum {{useLabelInErrorText ? label : ''}} is {{!min ? form.controls[name].errors?.['min']?.min : ''}}
			<ng-content select="[min]"></ng-content>
		</span>
		<span *ngIf="form.controls[name].errors?.['max']">
			Maximum {{useLabelInErrorText ? label : ''}} is {{!max ? form.controls[name].errors?.['max']?.max : ''}}
			<ng-content select="[max]"></ng-content>
		</span>
		<span *ngIf="form.controls[name].errors?.['email']">
			{{useLabelInErrorText ? label : ''}} must be valid
		</span>
		<span *ngIf="form.controls[name].errors?.['pattern']">
			{{useLabelInErrorText ? label : ''}} must follow pattern ({{pattern}})
		</span>
		<span *ngIf="form.controls[name].errors?.['minlength']">
			<!-- {{label}} -->
			<ng-content select="[minlength]"></ng-content>
		</span>
		<span *ngIf="form.controls[name].errors?.['maxlength']">
			{{useLabelInErrorText ? label : 'This Field'}} can't exceed
			{{form.controls[name].errors?.['maxlength'].requiredLength}} characters
			({{form.controls[name].errors?.['maxlength'].actualLength}}/{{form.controls[name].errors?.['maxlength'].requiredLength}})
			<!-- <ng-content select="[maxlength]"></ng-content> -->
		</span>
	</span>
	<span class="text-xs mt-0.5 ml-3"
		*ngIf="helpText && (!form.controls[name].errors || !form.controls[name].touched)">{{ helpText }}
	</span>
</div>